let lastId = 0;

export const getUniqueId = (prefix?: string) => {
    lastId++;
    return `${prefix}-${lastId}`;
};
